import "./CategoryServiceDetailsComponent.scss"
import React, {useState} from "react";
import {ImageConfig} from "../../../../constants";

interface ICategoryServiceDetailsComponent {
    selectedServiceDetails?: any;
    selectedCategoryDetails?: any;
    handleCategoryServiceModalClose?: any;
}

const CategoryServiceDetailsComponent = (props: ICategoryServiceDetailsComponent) => {
    const {selectedCategoryDetails, selectedServiceDetails, handleCategoryServiceModalClose} = props;
    const [selectedDetailsType, setSelectedDetailsType] = useState("category");
    return (
        <div className={'category-service-details-modal-component-screen d-flex'}>
            <div
                className={'flex-1 primary-details-wrapper d-flex align-items-center justify-content-center flex-direction-column'}>
                <div className={'service-category-text-header d-flex align-items-center mrg-bottom-25'}>
                    Get to know our <br/>
                    services better
                </div>

                <div className={'mrg-bottom-50 service-category-text-sub-header'}>
                    Select an option below to know more about it.
                </div>
                <div>
                    {selectedCategoryDetails &&
                        <div
                            className={`d-flex justify-content-space-between align-items-center details-card ${selectedDetailsType === "category" ? 'active' : 'not-active'}`}
                            onClick={() => {
                                setSelectedDetailsType("category");
                            }}>
                            <div className={'d-flex'}>
                                <div>
                                    <img className={''} src={selectedCategoryDetails?.image?.url}
                                         width={59} height={49}
                                         alt={selectedCategoryDetails?.name}/>
                                </div>
                                <div
                                    className={'name-text-item d-flex mrg-left-15 align-items-center'}>{selectedCategoryDetails?.name}</div>
                            </div>
                            <div>
                                <ImageConfig.ServiceCardNavigatorIcon
                                    color={`${selectedDetailsType === "category" ? "#FFFFFF" : "#66FFE0"}`}/>
                            </div>
                        </div>
                    }
                    {selectedServiceDetails &&
                        <div
                            className={`d-flex justify-content-space-between align-items-center details-card mrg-top-20 ${selectedDetailsType === "service" ? 'active' : 'not-active'}`}
                            onClick={
                                () => {
                                    setSelectedDetailsType("service");
                                }
                            }>
                            <div className={'d-flex'}>
                                <div>
                                    <img className={''} src={selectedServiceDetails?.image?.url}
                                         width={59} height={49}
                                         alt={selectedServiceDetails?.name}/>
                                </div>
                                <div
                                    className={'name-text-item d-flex mrg-left-15 align-items-center'}>{selectedServiceDetails?.name}</div>
                            </div>
                            <div>
                                <ImageConfig.ServiceCardNavigatorIcon
                                    color={`${selectedDetailsType === "service" ? "#FFFFFF" : "#66FFE0"}`}/>
                            </div>
                        </div>}
                </div>
            </div>
            <div className={'flex-1 secondary-details-wrapper pdd-30'}>
                <div className={'d-flex align-items-right cursor-pointer justify-content-right mrg-bottom-25'}
                     onClick={() => {
                         handleCategoryServiceModalClose()
                     }}>
                    <ImageConfig.CloseIcon color={"#1479FF"}/>
                </div>
                {(selectedCategoryDetails && selectedDetailsType === "category") &&
                    <div>
                        <div className={'name-header-service-category mrg-bottom-10'}>
                            {selectedCategoryDetails?.name}
                        </div>
                        <div className={'content-description-service-header-text'}
                             dangerouslySetInnerHTML={{__html: selectedCategoryDetails?.description}}/>
                    </div>
                }
                {(selectedServiceDetails && selectedDetailsType === "service") &&
                    <div>
                        <div className={'name-header-service-category mrg-bottom-10'}>
                            {selectedServiceDetails?.name}
                        </div>
                        <div className={'content-description-service-header-text'}
                             dangerouslySetInnerHTML={{__html: selectedServiceDetails?.description}}/>
                    </div>
                }

            </div>
        </div>
    )
}

export default CategoryServiceDetailsComponent
